module.exports = __webpack_public_path__ + "img/s4-4.5afe8884.jpg";